module.exports = __webpack_public_path__ + "static/media/explore_col_2.ed2c0108.svg";